var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchSidebarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66683 14C11.1646 14 14.0002 11.1645 14.0002 7.6667C14.0002 4.1689 11.1646 1.33337 7.66683 1.33337C4.16903 1.33337 1.3335 4.1689 1.3335 7.6667C1.3335 11.1645 4.16903 14 7.66683 14Z",
    stroke: "#6E6E6E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6668 14.6667L13.3335 13.3334",
    stroke: "#6E6E6E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchSidebarIcon);
export default __webpack_public_path__ + "static/media/search-sidebar-icon.c11c918ceac90f588a7e898f2d36c821.svg";
export { ForwardRef as ReactComponent };